import {useQuery, UseQueryResult} from 'react-query';
import {saveAs} from 'file-saver';
import {request} from '../Client';
import {ApiOperation} from '../utilis/Api';
import useSetLoadingState from '../../utilis/useSetLoadingState';

interface IUseGetDocumentQueryProps {
  isin: string,
  documentLocales: string,
  documentType: string,
  tagSet: string[],
}

const useGetDocumentQuery = (props: IUseGetDocumentQueryProps): UseQueryResult<Blob> => {
  const query = useQuery(['getDocument', props], async () => {
    const res = await request<Blob>({
      operation: ApiOperation.GetDocument,
      params: {
        ...props,
        tagSet: props.tagSet.join(',')
      }
    });

    if (res.headers['content-type'] !== 'application/pdf') {
      throw new Error('Response is not a pdf file');
    }

    return res.data;
  }, {
    enabled: false,
    onSuccess: (data) => {
      const file = new Blob([data], {
        type: 'application/pdf',
      });
      saveAs(file, `${props.isin}_${props.documentType}_${props.documentLocales}`);
    }
  });

  useSetLoadingState(query.isFetching);

  return query;
}

export default useGetDocumentQuery;